// component
import React from 'react';
import PropTypes from 'prop-types';

import { Helmet } from 'react-helmet';

import '~/sass/modules/_search.scss';
import { withRouter } from '#/renderer/router';

// Components
import ProductBox from '~/components/productBox/ProductBox';

const CatalogGrid = ({ productInfo, addonsList, categorySlugSearch, keyword }) => {
  const items = (productInfo || []).map((v, i) => {
    const keys = `catalog--${i}--${v.part_number}`;
    if (addonsList.some(x => x.part_number === v.part_number)) {
      if (productInfo.length !== 1) {
        return null;
      } else return <NotFound key={i} keyword={keyword} />;
    }
    return <ProductBox items={v} key={keys} categorySlugSearch={categorySlugSearch} />;
  });

  return (
    <section className="search--grid">
      { items }
      <article className="grid" />
      <article className="grid" />
      <article className="grid" />
    </section>
  );
};

const NotFound = (props) => {
  const metaTitle = props.keyword;
  return (
    <section className="search--notfound">
      <p>Lo sentimos la búsqueda <b>{metaTitle}</b> no ha coincidido con ningún equipo.</p>
      <ul>
        <li>Intenta de nuevo usando:</li>
        <li><span>Términos más generales</span></li>
        <li><span>Revisando la ortografía</span></li>
      </ul>
    </section>
  );
};

const UI = (props) => {
  const productList = props.productList;
  const results = productList.length > 0;
  const metaTitle = props.keyword;
  return (
    <main>
      <section className="catalog">
        <header className="catalog--header">
          <h1>
            Resultados de búsqueda: <b>{metaTitle}</b>
          </h1>
        </header>
        {props.searchResult &&
          (results ? (
            <CatalogGrid
              productInfo={props.productList}
              eSpot={props.eSpot}
              addonsList={props.addonsList}
              categorySlugSearch={props.categorySlugSearch}
              keyword={props.keyword}
            />
          ) : (
            <NotFound keyword={props.keyword} />
          ))}
      </section>
    </main>
  );
};

UI.propTypes = {
  productList: PropTypes.arrayOf(PropTypes.any),
  eSpot: PropTypes.shape({}),
  addonsList: PropTypes.arrayOf(PropTypes.shape({})),
};

UI.defaultProps = {
  productList: [],
  eSpot: {},
  addonsList: [],
};

CatalogGrid.propTypes = {
  productInfo: PropTypes.arrayOf(PropTypes.any),
  addonsList: PropTypes.arrayOf(PropTypes.shape({})),
};

CatalogGrid.defaultProps = {
  productInfo: [],
  addonsList: [],
};

export default withRouter(UI);
